// @flow
import CafeteriaOrders from './CafeteriaOrders';

export default CafeteriaOrders;
